module.exports = __webpack_public_path__ + "media/images/icons/checkmark-be77d22f657e4b9eb30112031e480eaa.svg";